import { render, staticRenderFns } from "./UfPrinting.vue?vue&type=template&id=3ff890b2&scoped=true&"
import script from "./UfPrinting.vue?vue&type=script&lang=js&"
export * from "./UfPrinting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff890b2",
  null
  
)

export default component.exports